module.exports = __webpack_public_path__ + "img/m.da3ae0c8.svg";